import { isFulfilled } from "@reduxjs/toolkit";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppDispatch } from "../../../app/hooks";
import DialogComponent from "../../../common/components/functional/dialogs/DialogComponent";
import { Talent } from "../../talents/talentAPI";
import { fetchHrExpertUser } from "../../user/expertUsersSlice";
import { HrExpertUser } from "../../user/types/entities";
import TalentInfoRow from "../talentProfileSummary/TalentInfoRow";
import TalentHrRepresentative from "./TalentHrRepresentative";
import TalentHrRepresentativeForm from "./TalentHrRepresentativeForm";

type Props = {
  talent: Talent;
  isLoading: boolean;
  disableEdit: boolean;
};

const TalentHrDetails = ({ talent, isLoading, disableEdit }: Props) => {
  const [showEditModal, setShowEditModal] = useState(false);
  const [hrRep, setHrRep] = useState<HrExpertUser>();

  const { t } = useTranslation("talentProfile");

  const dispatch = useAppDispatch();

  useEffect(() => {
    if (talent?.hrRepresentative) {
      dispatch(fetchHrExpertUser(talent?.hrRepresentative)).then((action) => {
        if (isFulfilled(action)) {
          // set hr representative with eezyCompanyName
          setHrRep(action.payload);
        }
      });
    }
  }, [talent, dispatch]);

  const onClose = () => setShowEditModal(false);

  return (
    <>
      <TalentInfoRow label={t("myHr")}>
        <TalentHrRepresentative
          hrRep={hrRep}
          isLoading={isLoading}
          setShowEditModal={setShowEditModal}
          disableEdit={disableEdit}
        />
      </TalentInfoRow>
      <DialogComponent
        open={showEditModal}
        onClose={onClose}
        autoWidth
        sx={{ width: "470px" }}
      >
        <TalentHrRepresentativeForm
          hrRep={hrRep}
          onClose={onClose}
          talent={talent}
        />
      </DialogComponent>
    </>
  );
};

export default TalentHrDetails;
